export default {
  reportData: null,
  isFetchingReportData: false,
  isExportingReport: false,
};
